import { createQueryHook } from "../factory";

const providerKeys = {
  all: ["providerKeys"] as const,
  lists: () => [...providerKeys.all, "list"] as const,
  list: <T>(filters: T) => [...providerKeys.lists(), filters] as const,
};

export const providers = {
  getProviders: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.providers.getProviders,
    queryKeyFn: providerKeys.list,
  }),
};
